import supportsHistory from '../util/supportsHistory';
import {$} from '../util/jq';
import betweenSurveyPages from './betweenSurveyPages';
import defaultTransition from './defaultTransition';

const isBetweenSurveyPages = (oldContentWrapper, template) => {
  return oldContentWrapper.hasClass('survey') && template === 'survey';
};

export default (event, data) => {

  const {html, template, reverse, url} = data;

  if (supportsHistory) {

    $('.infoTip').tooltip('dispose');

    const oldContentWrapper = $('#contentWrapper');
    const newContentWrapper = $(`<div>${html}</div>`);

    if (isBetweenSurveyPages(oldContentWrapper, template)) {
      betweenSurveyPages(oldContentWrapper, newContentWrapper, template, reverse, url);
    } else {
      defaultTransition(oldContentWrapper, newContentWrapper, template, reverse, url);
    }

  } else {
    window.location = url;
  }

};



// WEBPACK FOOTER //
// ./src/main/js/pageTransitions/index.js